(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ferrisWheel", [], factory);
	else if(typeof exports === 'object')
		exports["ferrisWheel"] = factory();
	else
		root["ferrisWheel"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FerrisWheel',
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 800
    },
    circleImageRadius: {
      type: Number,
      default: 100
    },
    background: {
      type: String,
      default: ''
    },
    circleData: {
      type: Array,
      default: function _default() {
        return [
          /*{
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': 1526882227000,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1526882236000,
            'recordVersion': 0,
            'resourceId': '8',
            'url': '',
            'path': null,
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-access-plat.png'),
            'displayOrder': 2,
            'hidden': 0,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': null,
            'recordVersion': null,
            'resourceId': '9',
            'url': '',
            'path': null,
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1554876233000,
            'recordVersion': 0,
            'resourceId': '10',
            'url': '',
            'path': 'system/department.html',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-shiny-area.png'),
            'displayOrder': 2,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': null,
            'recordVersion': null,
            'resourceId': '11',
            'url': '',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': null,
            'recordVersion': null,
            'resourceId': '12',
            'url': 'http://222.179.155.108:30026/apm/autoLogin?authorization=',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': 1556437492000,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1556437499000,
            'recordVersion': null,
            'resourceId': '27',
            'url': '',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaacdcccc',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': 1556437492000,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1556437499000,
            'recordVersion': null,
            'resourceId': '27',
            'url': '',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon':require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          }*/
        ];
      }
    }
  },
  data: function data() {
    return {
      pointPosition: [], //位置信息
      pointAve: {
        ox: this.width / 2 - (this.circleImageRadius + 10) / 2,
        oy: this.height / 2 - (this.circleImageRadius + 10) / 2,
        r: Number(this.width / 2 - (this.circleImageRadius + 10) / 2)
      }, //圆信息
      imageHover: false //wheel是否有移入
    };
  },

  watch: {
    circleData: function circleData(val) {
      this.getPointPosition(this.pointAve.r, this.pointAve.ox, this.pointAve.oy, val.length);
    }
  },
  created: function created() {
    this.getPointPosition(this.pointAve.r, this.pointAve.ox, this.pointAve.oy, this.circleData.length);
  },
  mounted: function mounted() {},

  methods: {
    //二级菜单-图标位置信息
    circlePosition: function circlePosition(index) {
      //当前二级菜单数量
      return { 'top': this.pointPosition[index].x + 'px', 'left': this.pointPosition[index].y + 'px' };
    },

    //获取二级菜单 等分圆的点的位置信息 r 半径 ox 圆心横坐标 oy 圆心纵坐标 count 等分点个数
    getPointPosition: function getPointPosition(r, ox, oy, count) {
      this.pointPosition = [];
      var radians = Math.PI / 180 * Math.round(360 / count);
      for (var i = 0; i < count; i++) {
        var x = ox + r * Math.sin(radians * i);
        var y = oy + r * Math.cos(radians * i);
        this.pointPosition.push({ x: x, y: y });
      }
      console.log(this.pointPosition);
    },

    /**
     * 转动图片的点击
     */
    wheelClick: function wheelClick(item) {
      this.$emit('wheelClick', item);
    },

    /**
     * 转动图片的点击
     */
    wheelMouseover: function wheelMouseover(item) {
      this.imageHover = true;
      this.$emit('wheelMouseover', item);
    },

    /**
     * 转动图片的点击
     */
    wheelMouseout: function wheelMouseout(item) {
      this.imageHover = false;
      this.$emit('wheelMouseout', item);
    }
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ferris_wheel__ = __webpack_require__(2);
// sumFunction 插件对应组件的名字


// Vue.js 的插件应当有一个公开方法 install 。第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象
// 参考：https://cn.vuejs.org/v2/guide/plugins.html#%E5%BC%80%E5%8F%91%E6%8F%92%E4%BB%B6
// 此处注意，组件需要添加name属性，代表注册的组件名称，也可以修改成其他的

__WEBPACK_IMPORTED_MODULE_0__ferris_wheel__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__ferris_wheel__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__ferris_wheel__["a" /* default */]);
}; //注册组件


// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) {
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__ferris_wheel__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ferris_wheel_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1d3109_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ferris_wheel_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a1d3109"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ferris_wheel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1d3109_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ferris_wheel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2cab7074", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".ferris-wheel[data-v-6a1d3109]{margin-left:20%;position:relative;-webkit-animation:circleRoate-data-v-6a1d3109 50s infinite linear}.ferris-wheel .circle[data-v-6a1d3109]{position:absolute;z-index:99;display:flex;justify-content:center;flex-direction:column;align-items:center;-webkit-animation:animtrans-data-v-6a1d3109 50s infinite linear}.ferris-wheel .circle.rotate-paused[data-v-6a1d3109]{-webkit-animation-play-state:paused;animation-play-state:paused}.ferris-wheel .circle.rotate-running[data-v-6a1d3109]{-webkit-animation-play-state:running;animation-play-state:running}@-webkit-keyframes circleRoate-data-v-6a1d3109{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@-webkit-keyframes animtrans-data-v-6a1d3109{0%{transform:rotate(1turn)}to{transform:rotate(0deg)}}.ferris-wheel.rotate-paused[data-v-6a1d3109]{-webkit-animation-play-state:paused;animation-play-state:paused}.ferris-wheel.rotate-running[data-v-6a1d3109]{-webkit-animation-play-state:running;animation-play-state:running}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ferris-wheel",class:_vm.imageHover ? 'rotate-paused' : 'rotate-running',style:({width: _vm.width.toString() + 'px', height: _vm.height.toString() + 'px', background: _vm.background})},_vm._l((_vm.circleData),function(item,index){return _c('div',{key:index.toString() + 'circleData',staticClass:"circle",class:_vm.imageHover ? 'rotate-paused' : 'rotate-running',style:(_vm.circlePosition(index)),on:{"click":function($event){return _vm.wheelClick(item)},"mouseover":function($event){return _vm.wheelMouseover(item)},"mouseout":function($event){return _vm.wheelMouseout(item)}}},[_c('img',{attrs:{"src":item.icon}}),_vm._v(" "),_c('span',{staticClass:"circle-span"},[_vm._v(_vm._s(item.resourceDesc))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ferrisWheel.js